/* =========================================================
   Neubau D · Warenkorb (Schublade #kd-cart und Seite /cart)
   Quelle: showcase _assets-d/src/cart.js. Alle Zahlen kommen von Shopify:
   jede Änderung geht an /cart/change.js bzw. /cart/update.js mit sections=…,
   danach werden nur die Teile [data-kc-part] ausgetauscht. Zeilen werden einzeln
   ersetzt, eine entfernte Zeile bleibt als gleich hohe Textzeile stehen (nichts springt).
   Anfragen laufen nacheinander (eine Warteschlange), Mengenklicks werden kurz gesammelt.
   Ereignisse: hört auf kd:cart-added (d-kd.js) und kd-open (#kd-cart); sendet kd:cart-updated.
   Wurzel: [data-kc-root] ([data-kc] gehört dem Cookie-Banner).
   window.KC = { refresh, apply }
   ========================================================= */
(() => {
  if (window.KC) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfg = window.KD_CFG || {};
  const base = (cfg.routes && cfg.routes.root) || '/';
  const url = (p) => (base.endsWith('/') ? base : base + '/') + p;
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));
  let T = {};
  try { T = JSON.parse(($('[data-kc-t]') || {}).textContent || '{}'); } catch (e) { T = {}; }

  const roots = () => $$('[data-kc-root]');
  const ids = () => roots().map((r) => r.dataset.kcSection).filter(Boolean);

  /* Warteschlange: eine Anfrage nach der anderen, damit Summen nie veralten */
  let chain = Promise.resolve();
  let pending = 0;
  const busy = (on) => { pending += on ? 1 : -1; roots().forEach((r) => r.setAttribute('aria-busy', String(pending > 0))); };
  const queue = (fn) => {
    busy(true);
    const run = chain.then(fn);
    chain = run.catch(() => {}).then(() => busy(false));
    return run;
  };

  /* Vorschau-Themes: preview_theme_id muss bei Section-Abrufen mitlaufen */
  const keep = () => {
    const q = new URLSearchParams(location.search); const o = new URLSearchParams();
    ['preview_theme_id'].forEach((k) => { if (q.get(k)) o.set(k, q.get(k)); });
    return o;
  };
  async function post(path, body) {
    const list = ids();
    if (list.length) { body.sections = list.join(','); body.sections_url = location.pathname + (keep().toString() ? '?' + keep() : ''); }
    const r = await fetch(url(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) { const err = new Error(data.description || data.message || T.error || 'Error'); err.data = data; throw err; }
    return data;
  }
  async function fetchSections() {
    const list = ids(); if (!list.length) return null;
    const q = keep(); q.set('sections', list.join(','));
    /* ohne Accept: application/json – sonst antwortet Shopify auf /products/… mit dem Produkt-JSON statt der Sections */
    const r = await fetch(location.pathname + '?' + q);
    return r.ok ? r.json() : null;
  }
  async function fetchCart() {
    const r = await fetch(url('cart.js'), { headers: { Accept: 'application/json' } });
    return r.json();
  }

  /* ---------- Teile austauschen ---------- */
  function mergeLines(cur, next) {
    const nextRows = $$('.kc-line', next);
    const curRows = $$('.kc-line', cur);
    const has = new Set(curRows.map((r) => r.dataset.key));
    const fits = nextRows.length && !$('.kc-empty', next) && nextRows.every((r) => has.has(r.dataset.key));
    if (!fits) { cur.replaceWith(next); return; }
    /* Sammelzeile des Bundle-Baukastens (d-cart-part, data-kc-group) mitziehen */
    const g = $('[data-kc-group]', cur); const ng = $('[data-kc-group]', next);
    if (g && ng) g.replaceWith(ng); else if (g) g.remove(); else if (ng) cur.prepend(ng);
    const byKey = new Map(nextRows.map((r) => [r.dataset.key, r]));
    curRows.forEach((row) => {
      const n = byKey.get(row.dataset.key);
      if (!n) { gone(row); return; }
      if (row.kcQ) return; /* Kunde klickt gerade weiter: seine Zahl bleibt stehen, die nächste Antwort bringt den Stand */
      const err = $('.kc-line__err', row).textContent;
      if (row.kcErr && err) $('.kc-line__err', n).textContent = err;
      n.kcErr = row.kcErr;
      if (row.classList.contains('is-changed')) { n.classList.add('is-changed'); n.kcT = setTimeout(() => n.classList.remove('is-changed'), 400); }
      row.replaceWith(n);
    });
  }
  function apply(sections, opts = {}) {
    if (!sections) return;
    roots().forEach((root) => {
      const html = sections[root.dataset.kcSection]; if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      $$('[data-kc-part]', doc).forEach((part) => {
        const name = part.dataset.kcPart;
        if (opts.skip && opts.skip.includes(name)) return;
        const cur = $(`[data-kc-part="${name}"]`, root); if (!cur) return;
        const next = document.importNode(part, true);
        if (name === 'lines') mergeLines(cur, next); else cur.replaceWith(next);
      });
      /* Nach einem Austausch mit leerem Korb ohne Platzhalter: nichts weiter */
    });
  }
  function count(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    $$('[data-bag-n]').forEach((el) => { el.textContent = cart.item_count ? String(cart.item_count) : ''; });
    emit('kd:cart-updated', { cart, source: 'kc' });
  }
  async function refresh(opts = {}) {
    return queue(async () => {
      const [sections, cart] = await Promise.all([fetchSections(), fetchCart()]);
      apply(sections, opts); count(cart);
      return cart;
    });
  }

  /* ---------- Zeilen ---------- */
  const lineOf = (el) => el.closest('.kc-line');
  function lineErr(row, text) {
    const box = row && $('.kc-line__err', row); if (!box) return;
    box.textContent = text || ''; row.kcErr = !!text;
  }
  function gone(row) {
    const g = document.createElement('div');
    g.className = 'kc-gone'; g.dataset.key = row.dataset.key;
    g.style.minHeight = row.offsetHeight + 'px';
    g.innerHTML = `<span>${(T.removed || '[title]').replace('[title]', esc(row.dataset.title || ''))}</span>`;
    const had = row.contains(document.activeElement);
    row.replaceWith(g);
    if (had) { g.tabIndex = -1; g.focus({ preventScroll: true }); }
  }
  async function change(key, quantity) {
    return queue(async () => {
      try {
        const data = await post('cart/change.js', { id: key, quantity });
        apply(data.sections); count(data);
        const item = (data.items || []).find((i) => i.key === key);
        if (item && item.quantity < quantity) {
          $$('.kc-line').filter((r) => r.dataset.key === key).forEach((r) => lineErr(r, (T.maxQty || '').replace('[max]', item.quantity)));
        }
        return data;
      } catch (e) {
        const sections = await fetchSections().catch(() => null);
        apply(sections); count(await fetchCart().catch(() => null));
        $$('.kc-line').filter((r) => r.dataset.key === key).forEach((r) => lineErr(r, e.message));
      }
    });
  }
  function step(row, dir) {
    const min = +row.dataset.min || 1; const inc = +row.dataset.step || 1; const max = row.dataset.max ? +row.dataset.max : Infinity;
    const out = $('output', row); const now = +out.textContent || 0;
    let q = dir > 0 ? now + inc : now - inc;
    if (dir < 0 && q < min) { remove(row); return; }
    if (q > max) q = max;
    if (q === now) return;
    out.textContent = q; lineErr(row, '');
    const plus = $('[data-kc-plus]', row); if (plus) plus.disabled = q >= max;
    row.classList.add('is-changed');
    clearTimeout(row.kcQ);
    row.kcQ = setTimeout(() => { row.kcQ = null; change(row.dataset.key, q); }, 350);
  }
  function remove(row) {
    clearTimeout(row.kcQ); row.kcQ = null;
    const key = row.dataset.key; const title = row.dataset.title; const root = row.closest('[data-kc-root]');
    gone(row);
    /* Ansage über die Statuszeile von d-kd.js (die ersetzte Zeile allein wird nicht vorgelesen) */
    change(key, 0).then((cart) => {
      if (cart && window.KD) window.KD.cartSay((cfg.t || {}).cartRemoved, title, cart);
      /* Letzte Zeile weg (Teil ausgetauscht): Fokus bleibt in der Schublade */
      if (document.activeElement === document.body && root) $('[data-close]', root)?.focus({ preventScroll: true });
    });
  }

  /* ---------- Rabattcodes (Shopify prüft, wir zeigen nur an) ---------- */
  const active = (cart) => (cart.discount_codes || []).filter((c) => c.applicable).map((c) => c.code);
  function codeMsg(form, text, kind) {
    const f = form || $('[data-kc-code]'); if (!f) return;
    const m = $('[data-kc-code-msg]', f); if (m) m.textContent = text || '';
    f.classList.toggle('is-err', kind === 'err'); f.classList.toggle('is-ok', kind === 'ok');
  }
  const same = (a, b) => String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
  async function applyCode(code, form) {
    code = String(code || '').trim();
    if (!code) { codeMsg(form, T.codeEnter, 'err'); return; }
    codeMsg(form, T.codeChecking);
    return queue(async () => {
      try {
        const cart = await fetchCart();
        const now = active(cart);
        if (now.some((c) => same(c, code))) { codeMsg(form, T.codeActive, 'err'); return; }
        const data = await post('cart/update.js', { discount: [...now, code].join(',') });
        const hit = (data.discount_codes || []).find((c) => same(c.code, code));
        if (hit && hit.applicable) {
          apply(data.sections); count(data);
          codeMsg(form, T.codeApplied, 'ok'); codeIn(form, '');
        } else {
          /* Nicht anwendbar: Shopify behält den Code sonst still im Korb, also zurücksetzen */
          const back = await post('cart/update.js', { discount: now.join(',') });
          apply(back.sections); count(back);
          codeMsg(form, T.codeInvalid, 'err');
        }
      } catch (e) {
        codeMsg(form, T.codeInvalid, 'err');
      }
    });
  }
  /* Das Formular selbst wird nie ausgetauscht (nur [data-kc-part]), Eingabe und Meldung bleiben stehen */
  const codeIn = (form, v) => { const i = form && $('[data-kc-code-in]', form); if (i) i.value = v; };
  async function removeCode(code, btn) {
    const form = btn && btn.closest('[data-kc-root]') && $('[data-kc-code]', btn.closest('[data-kc-root]'));
    codeMsg(form, T.codeRemoving);
    return queue(async () => {
      try {
        const cart = await fetchCart();
        const rest = (cart.discount_codes || []).map((c) => c.code).filter((c) => !same(c, code));
        const data = await post('cart/update.js', { discount: rest.join(',') });
        apply(data.sections); count(data);
        codeMsg(form, T.codeRemoved, 'ok');
      } catch (e) { codeMsg(form, e.message, 'err'); }
    });
  }

  /* ---------- Bestellanweisungen ---------- */
  let noteT;
  function saveNote(area) {
    clearTimeout(noteT);
    noteT = setTimeout(() => {
      const note = area.value;
      queue(() => fetch(url('cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note }) }));
      $$('[data-kc-note]').forEach((a) => { if (a !== area) a.value = note; });
    }, 500);
  }

  /* ---------- Empfehlungen: Optionen wählen, hinzufügen, Karte bleibt stehen ---------- */
  function upPick(card) {
    const data = $('[data-up-variants]', card); if (!data) return;
    let list = []; try { list = JSON.parse(data.textContent); } catch (e) { return; }
    const sel = $$('select[data-opt]', card).map((s) => s.value);
    const v = list.find((x) => x.o.every((o, i) => o === sel[i]));
    const btn = $('[data-up-add]', card);
    if (!v) { btn.disabled = true; return; }
    btn.dataset.upAdd = v.id; btn.disabled = !v.a;
    btn.classList.remove('is-in');
    const p = $('[data-up-price]', card); if (p) p.textContent = v.p;
  }
  async function upAdd(btn) {
    if (btn.classList.contains('is-in') || btn.disabled || !window.KD) return;
    btn.disabled = true;
    const card = btn.closest('[data-up]');
    try {
      await queue(() => window.KD.cartAdd(btn.dataset.upAdd, 1));
      const icon = document.getElementById('kd-icon-check');
      btn.classList.add('is-in'); if (icon) btn.innerHTML = icon.innerHTML;
      btn.setAttribute('aria-label', btn.dataset.labelIn || '');
      const cart = await refresh({ skip: ['up'] });
      if (window.KD) window.KD.cartSay((cfg.t || {}).cartAdded, $('.kc-up__t', card)?.textContent.trim(), cart);
    } catch (e) {
      const row = card && $('.kc-up__p', card); if (row) row.textContent = e.message;
    } finally { btn.disabled = false; }
  }

  /* ---------- Ereignisse ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target; if (!t.closest || !t.closest('[data-kc-root]')) return;
    const minus = t.closest('[data-kc-minus]'); if (minus) { step(lineOf(minus), -1); return; }
    const plus = t.closest('[data-kc-plus]'); if (plus) { step(lineOf(plus), 1); return; }
    const rm = t.closest('[data-kc-remove]'); if (rm) { remove(lineOf(rm)); return; }
    const un = t.closest('[data-kc-uncode]'); if (un) { removeCode(un.dataset.kcUncode, un); return; }
    const rd = t.closest('[data-kc-redeem]'); if (rd) { const root = rd.closest('[data-kc-root]'); applyCode(rd.dataset.kcRedeem, $('[data-kc-code]', root)); return; }
    const up = t.closest('[data-up-add]'); if (up) upAdd(up);
  });
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f.matches && f.matches('[data-kc-code]')) { e.preventDefault(); applyCode(($('[data-kc-code-in]', f) || {}).value, f); return; }
    /* Auschecken: offene Mengenänderungen erst abschicken, dann weiter zu /checkout */
    if (f.closest && f.closest('[data-kc-root]') && f.classList.contains('kc-pay') && (pending > 0 || $$('.kc-line').some((r) => r.kcQ))) {
      e.preventDefault();
      $$('.kc-line').forEach((r) => {
        if (!r.kcQ) return;
        clearTimeout(r.kcQ); r.kcQ = null; change(r.dataset.key, +$('output', r).textContent);
      });
      chain.then(() => { const b = $('[data-kc-pay]', f); f.requestSubmit ? f.requestSubmit(b) : f.submit(); });
    }
  });
  document.addEventListener('input', (e) => { if (e.target.matches && e.target.matches('[data-kc-note]')) saveNote(e.target); });
  document.addEventListener('change', (e) => { const s = e.target; if (s.matches && s.matches('[data-up] select[data-opt]')) upPick(s.closest('[data-up]')); });

  /* Hinzugefügt (Kachel, Probe, Produktseite): Schublade auffrischen und öffnen; auf /cart nur auffrischen */
  let fresh = false;
  document.addEventListener('kd:cart-added', () => {
    refresh().then(() => { if ($('#kd-cart') && window.KD) { fresh = true; window.KD.open('kd-cart'); fresh = false; } });
  });
  /* Beim Öffnen: Stand holen (Apps oder ein anderer Tab können den Korb geändert haben) */
  document.addEventListener('kd-open', (e) => { if (e.target && e.target.id === 'kd-cart' && !fresh) refresh(); });
  /* Zurück-Taste (bfcache): Korb kann sich geändert haben */
  addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });

  window.KC = { refresh, apply: applyCode };
})();
